import { useCallback } from 'react';
import {
  useDeleteAssetsWithWarning,
  useDownloadAssetsWithWarning,
} from '@frameio/assets/operations';
import { getAssetParent } from '@frameio/assets/shared';
import { useApolloClient } from '@frameio/graphql-client';
import type { ProjectTreeItem } from '@frameio/project-tree';
import { useActiveProjectId } from '@frameio/shared/contexts';
import { FolderMenu, type FolderMenuProps } from '../../../FolderMenu';

type Props = {
  item: ProjectTreeItem;
} & Pick<FolderMenuProps, 'onNewFolderSelect' | 'onRenameSelect'>;

export function FolderContextMenu({
  item,
  onNewFolderSelect,
  onRenameSelect,
}: Props) {
  const projectId = useActiveProjectId() ?? '';
  const { cache } = useApolloClient();

  const deleteAssets = useDeleteAssetsWithWarning();
  const { downloadAssets } = useDownloadAssetsWithWarning();

  const handleDownloadAllSelect = () => {
    downloadAssets([item.id], {
      trackDownloadingState: false,
    });
  };

  const handleDeleteSelect = useCallback(() => {
    const asset = getAssetParent(cache, item.id);

    deleteAssets({
      assetIds: [item.id],
      parentId: asset?.parent?.id ?? '',
      projectId,
    });
  }, [cache, deleteAssets, item, projectId]);

  return (
    <FolderMenu
      folderId={item.id}
      isRootFolder={false}
      onDeleteSelect={handleDeleteSelect}
      onDownloadAllSelect={handleDownloadAllSelect}
      onNewFolderSelect={onNewFolderSelect}
      onRenameSelect={onRenameSelect}
      projectId={projectId}
      trackingSource="ProjectNavFolderMenu"
    />
  );
}
